import FakeButtons from './FakeButtons'
export default FakeButtons
